import * as wActs from './website-actions.js';
import * as sActs from './server-actions.js';
import * as wConst from '../consts/website-consts';
import { fetch, addTask } from "domain-task";


export function GetAdPackages(cc,size,utype=2,hcc="",referer) {
  return (dispatch,getState) => {
    dispatch({type: wConst.FETCH_ADSPACKS_PENDING, payload: false});
    if(wActs.isNullOrEmpty(cc)) {
      cc = getState().Website.Request.CountryCode;
    }
    if(wActs.isNullOrEmpty(hcc)) {
      hcc = getState().Website.Request.CountryCode;
    }
    let ref = wActs.isNullOrEmpty(referer) ? wActs.GetReferer() : referer;
    let auth = wActs.getBearer(getState().Website.Settings.ServerParams.Cookies);
    if(wActs.isNullOrEmpty(auth)) {
      auth = sActs.getServerCookie(getState().Website.ServerParams.Cookies,"auth");
    }
    let headers = {
      'X-Alt-Referer': ref,
    };
    if(!wActs.isNullOrEmpty(auth)) {
      headers.Authorization = "Bearer " + auth;
    }
    let adp = fetch(`${wConst.ROOT_URL()}/creatives/packages?country=${cc}&size=${encodeURIComponent(size)}&userType=${utype}&homeCountry=${hcc}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (pdata) {
        if (pdata.Code !== 200) {
          dispatch({type: wConst.FETCH_ADSPACKS_REJECTED, payload: pdata});
          dispatch(wActs.showWarning("WARN", pdata.Message));
        } else {
          dispatch({type: wConst.FETCH_ADSPACKS_FULLFILLED, payload: pdata});
        }
      }).catch(function (ex) {
        dispatch({ type: wConst.FETCH_ADSPACKS_REJECTED, payload: ex.toString() });
        dispatch(wActs.showWarning("WARN", ex.toString()));
     });
  }
}
export function GetAdSizes(utype,cc,hcc) {
  return (dispatch,getState) => {
    dispatch({type: wConst.FETCH_ADSSIZES_PENDING, payload: false});
    dispatch({type: wConst.FETCH_ADSPACKS_PENDING, payload: false});

    let ref = wActs.GetReferer();
    let auth = wActs.getBearer(getState().Website.Settings.ServerParams.Cookies);
    if(wActs.isNullOrEmpty(auth)) {
      auth = sActs.getServerCookie(getState().Website.ServerParams.Cookies,"auth");
    }
    let headers = {
      'X-Alt-Referer': ref,
    };
    if(!wActs.isNullOrEmpty(auth)) {
      headers.Authorization = "Bearer " + auth;
    }
    let sizes = fetch(`${wConst.ROOT_URL()}/creatives/sizes?userType=${utype}&country=${cc}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (sdata) {
        if (sdata.Code !== 200) {
          dispatch({type: wConst.FETCH_ADSSIZES_REJECTED, payload: sdata});
          dispatch(wActs.showWarning("WARN", pdata.Message));
        } else {
          let size = "200x100";
          if(sdata.Result.length>0) { size = sdata.Result[0].Name; } else {sdata.Result.push({Name: "200x100"})}
          dispatch({type: wConst.FETCH_ADSSIZES_FULLFILLED, payload: sdata});
          dispatch(GetAdPackages(cc,size,utype,hcc,ref));
        }
      }).catch(function (ex) {
        throw ex;
        dispatch({ type: wConst.FETCH_ADSSIZES_REJECTED, payload: ex.toString() });
        dispatch(wActs.showWarning("WARN", ex.toString()));
      });
  }
}
export function GetAdUrlInfo(url) {
  return (dispatch, getState) => {
    dispatch({ type: wConst.FETCH_ADSURL_PENDING, payload: false });
    let auth = wActs.getBearer(getState().Website.Settings.ServerParams.Cookies);
    if (wActs.isNullOrEmpty(auth)) {
      auth = sActs.getServerCookie(getState().Website.ServerParams.Cookies, "auth");
    }
    let headers = {
      //'Authorization': "Bearer " + auth
    };
    let ads = fetch(`${wConst.ROOT_URL()}/creatives/link?url=${encodeURIComponent(url)}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
      if(data.Code == 200) {
        dispatch({ type: wConst.FETCH_ADSURL_FULLFILLED, payload: data });
      } else {
        dispatch({ type: wConst.FETCH_ADSURL_REJECTED, payload: data });
        dispatch(wActs.showWarning("WARN", "Could not load url info"));
      }
    }).catch(function (ex) {
      dispatch({ type: wConst.FETCH_ADSURL_REJECTED, payload: ex.toString() });
      dispatch(wActs.showWarning("WARN", "Could not load url info"));
    });
  }
}
export function UploadAd(data) {
  return (dispatch, getState) => {
    dispatch({ type: wConst.FETCH_ADUPLOAD_PENDING, payload: false });
    let ref = wActs.GetReferer();
    let auth = wActs.getBearer(getState().Website.Settings.ServerParams.Cookies);
    if (wActs.isNullOrEmpty(auth)) { auth = sActs.getServerCookie(getState().Website.ServerParams.Cookies, "auth"); }
    let headers = {
      'X-Alt-Referer': ref,
    };
    if (!wActs.isNullOrEmpty(auth)) { headers.Authorization = "Bearer " + auth; }
    let fdata = new FormData();
    fdata.append('file',data.file);
    fdata.append('filename',data.filename);
    let upl = fetch(`${wConst.ROOT_URL()}/creatives/upload?packageId=${data.packid}&title=${encodeURIComponent(data.title)}&targetUrl=${encodeURIComponent(data.url)}`, { method: "POST", headers: headers, body: fdata})
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code == 200) {
          dispatch({ type: wConst.FETCH_ADUPLOAD_FULLFILLED, payload: data });
        } else {
          dispatch({ type: wConst.FETCH_ADUPLOAD_REJECTED, payload: data });
          dispatch(wActs.showWarning("WARN", data.Message));
        }
      }).catch(function (ex) {
        dispatch({ type: wConst.FETCH_ADUPLOAD_REJECTED, payload: ex.toString() });
        dispatch(wActs.showWarning("WARN", "Could not upload image."));
      });
  }
}


export function GetAdDataNew(referer,ip) {
  return (dispatch,getState) => {
    dispatch({type: wConst.FETCH_ADS_PENDING, payload: false});
    let ref = wActs.isNullOrEmpty(referer) ? wActs.GetReferer() : referer;
    let auth = wActs.getBearer(getState().Website.Settings.ServerParams.Cookies);
    if (wActs.isNullOrEmpty(auth)) { auth = sActs.getServerCookie(getState().Website.ServerParams.Cookies, "auth"); }
    let headers = {
      'X-Alt-Referer': ref,
    };
    if(!wActs.isNullOrEmpty(ip)) {
      headers['X-Alt-IP'] = ip;
    }
    if (!wActs.isNullOrEmpty(auth)) { headers.Authorization = "Bearer " + auth; }

    let ccs = fetch(`${wConst.ROOT_URL()}/list/country`, { headers: headers})
      .then(resp => resp.json())
      .then(function (ccdata) {
        let ads = fetch(`${wConst.ROOT_URL()}/creatives/dashboard`, { method: "GET", headers: headers})
          .then(resp => resp.json())
          .then(function (data) {
            if(data.Code === 200) {
              let payload = {
                Countries: {Loaded: true, Code: 200, Result: data.Result.Countries},
                Sizes: {Loaded: true, Code: 200, Result: data.Result.Sizes},
                Packages: {Loaded: true, Code: 200, Result: data.Result.Packages},
                UserTypes: {Loaded: true, Code: 200, Result: data.Result.UserTypes},
                AllCountries: {Loaded: true, Code: 200, Result: ccdata.Result},
              }
              delete data.Result.Countries;
              delete data.Result.Sizes;
              delete data.Result.Packages;
              delete data.Result.UserTypes;
              payload.UserInfo = {Loaded: true, Code: 200, Result: data.Result};

              if(wActs.isNullOrEmpty(payload.UserInfo.Result.Home.Country.Code)) {
                payload.UserInfo.Result.Home.Country = payload.UserInfo.Result.Current.Country;
              }

              dispatch({ type: wConst.FETCH_ADS_FULLFILLED, payload: payload});
            } else {
              dispatch({ type: wConst.FETCH_ADS_REJECTED, payload: data});
            }
          }).catch(function (ex) {
            throw ex;
            //dispatch({ type: wConst.FETCH_ADS_REJECTED, payload: {Code: 500, Message: ex.toString()}});
            //dispatch(wActs.showWarning("WARN", "Could not load Ad package data: " + ex.toString()));
        });
        addTask(ads);
      }).catch(function (ex) {
        throw ex;
        //dispatch({ type: wConst.FETCH_ADS_REJECTED, payload: {Code: 500, Message: ex.toString()}});
        //dispatch(wActs.showWarning("WARN", "Could not load Ad package data: " + ex.toString()));
      });
      addTask(ccs);
  }
}




export function PayByCredits(dta) {
  return (dispatch,getState) => {
    dispatch({ type: wConst.DEF_CHECKORDER_PENDING, payload: false });
    let ref = wActs.GetReferer();
    let auth = wActs.getBearer(getState().Website.Settings.ServerParams.Cookies);
    if (wActs.isNullOrEmpty(auth)) { auth = sActs.getServerCookie(getState().Website.ServerParams.Cookies, "auth"); }
    let headers = {
      'X-Alt-Referer': ref,
      'Content-type': "application/json; charset=utf-8"
    };
    if (!wActs.isNullOrEmpty(auth)) { headers.Authorization = "Bearer " + auth; }
    fetch(`/api/credits/pay`, { method: "POST", headers: headers, body: JSON.stringify(dta)})
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code == 200) {
          dispatch({ type: wConst.DEF_CHECKORDER_SUCCESS, payload: data });
        } else {
          dispatch({ type: wConst.DEF_CHECKORDER_FAILED, payload: data });
          dispatch(wActs.showWarning("WARN", data.Message));
        }
      }).catch(function (ex) {
        dispatch({ type: wConst.DEF_CHECKORDER_FAILED, payload: ex.toString() });
        dispatch(wActs.showWarning("WARN", "Could not pay by credits: " + ex.toString()));
    });
  }
}
